import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { largeBreakpoint } from "config/media";

import { parseISO } from "date-fns";
import BillingItem from "../BillingItems/BillingItem";
import ShowMore from "./ShowMore";
import BillingItemsHeaders from "./BillingItemsHeader";
import NoItems from "./NoItems";

const appendDate = (items) =>
  items.map((item) => ({ ...item, postedOn: parseISO(item.posted_on) }));

const sortItemsBy = (sortOrder, sortBy) => (items) =>
  items.sort((a, b) => {
    if (sortOrder === "ASC") {
      return a[sortBy] - b[sortBy];
    }

    return b[sortBy] - a[sortBy];
  });

const limitIf = ({ shouldLimit, limit }) => {
  return (items) => (shouldLimit ? items.slice(0, limit) : items);
};

const BillingItemsTable = ({
  items,
  tab,
  hasActiveFilters,
  expanded,
  setExpanded,
}) => {
  const [showAll, setShowAll] = useState(false);
  const [sortBy, setSortBy] = useState("postedOn");
  const [sortOrder, setSortOrder] = useState("DESC");
  const onExpand = (id) =>
    expanded === id ? setExpanded(null) : setExpanded(id);

  const itemLimit = 25;
  const sortItems = sortItemsBy(sortOrder, sortBy);
  const limitItems = limitIf({ shouldLimit: !showAll, limit: itemLimit });

  const filteredItems = sortItems(appendDate(items));
  const shownItems = limitItems(filteredItems);
  const showMore = filteredItems.length > itemLimit;

  return (
    <BillingItemsTableContainer>
      <BillingItemsHeaders
        sortBy={sortBy}
        setSortBy={setSortBy}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        tab={tab}
      />

      <BillingItemsContainer>
        {shownItems.map((item) => {
          return (
            <BillingItem
              style={{ padding: "0 var(--large-spacing)" }}
              item={item}
              tab={tab}
              key={item.id}
              expanded={expanded === item.id}
              setExpanded={setExpanded}
              onExpand={() => onExpand(item.id)}
            />
          );
        })}
      </BillingItemsContainer>

      {showMore && (
        <ShowMore expanded={showAll} onClick={() => setShowAll(!showAll)} />
      )}

      {filteredItems.length === 0 && (
        <NoItems tab={tab} hasActiveFilters={hasActiveFilters} />
      )}
    </BillingItemsTableContainer>
  );
};
BillingItemsTable.displayName = "BillingItemsTable";
BillingItemsTable.propTypes = {
  items: PropTypes.array,
  tab: PropTypes.string,
  hasActiveFilters: PropTypes.bool,
  expanded: PropTypes.string,
  setExpanded: PropTypes.func,
};

export default BillingItemsTable;

export const BillingItemsTableContainer = styled.div`
  @media all and (min-width: 576px) {
    margin-top: 20px;
  }
`;

export const BillingItemsContainer = styled.div`
  @media all and (max-width: ${largeBreakpoint}px) {
    div div.BillingItem {
      padding: var(--lg) 0;
    }

    div:nth-child(even) div.BillingItem {
      background-color: var(--wild-sand);
    }
  }
`;
